import React, { createRef } from "react";
import BaseComponent from "../../common/BaseComponent";
import NormalModal from "../modal";
import RequestReasonLogTable from "../requestReasonLogTable";
import "./index.scss";

const reasonRef = createRef();
export default class RequestReasonLogModal extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = {
      isModalOpen: false,
      closable: true,
      okText: "",
      cancelText: "",
      modalTitle: "Request Reason Log",
      tableKey: 0,
    };
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevProps.isReasonLogModalOpen !== this.props.isReasonLogModalOpen) {
      this.setState({
        isModalOpen: this.props.isReasonLogModalOpen,
        tableKey: this.state.tableKey + 1,
      });
    }
  }

  render() {
    const { isModalOpen, closable, okText, cancelText, modalTitle, destroyOnClose, tableKey } =
      this.state;
    return (
      <NormalModal
        testid="request-reason-log-modal"
        isModalOpen={isModalOpen}
        closable={closable}
        okText={okText}
        cancelText={cancelText}
        title={modalTitle}
        width={900}
        destroyOnClose={destroyOnClose}
        className="requestReasonLogModal"
        childContent={
          isModalOpen && (
            <RequestReasonLogTable
              dataSource={this.props.requestReasonLogData}
              isModalOpen={isModalOpen}
              reasonRef={reasonRef}
              tableKey={tableKey}
            />
          )
        }
        handleCancel={() => this.props.handleRequestReasonLog()}
        footer={null}
      />
    );
  }
}
